import { useState } from "react";
import {
  Box,
  Paper,
  TextField,
  Typography,
  Button,
  InputAdornment,
  IconButton,
  Link,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import logoLogin from "../static/logo_login.webp";
import { useAuth } from "../context/AuthContext";

export default function Login(){
  const navigate=useNavigate();
  const {login,logout}=useAuth();

  const [showPassword,setShowPassword]=useState(false);
  const [correo,setCorreo]=useState("");
  const [password,setPassword]=useState("");
  const [error,setError]=useState("");
  const [loading,setLoading]=useState(false);

  const handleSubmit=async(e)=>{
    e.preventDefault();
    setError("");

    if(!correo.trim()||!password){
      setError("Completa todos los campos");
      return;
    }

    setLoading(true);

    try{
      const user=await login(correo.trim(),password);

      if(user.rol==="DELEGADO"){
        navigate(user.must_change_password?"/actualizar-clave":"/delegado",{replace:true});
        return;
      }

      navigate("/admin",{replace:true});
    }catch(err){
      setError(err.message||"Error al iniciar sesión");
    }finally{
      setLoading(false);
    }
  };

  const handleBackHome=async(e)=>{
    e.preventDefault();
    await logout();
    navigate("/",{replace:true});
  };

  return (
    <Box sx={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",px:2,background:"#ffffff"}}>
      <Paper elevation={0} sx={{width:"100%",maxWidth:420,p:{xs:3,sm:4},borderRadius:"18px",border:"1px solid #E2E8F0",background:"#ffffff"}}>
        <Box component="img" src={logoLogin} alt="Logo" sx={{height:72,maxWidth:"100%",objectFit:"contain",display:"block",mx:"auto",mb:2.5}} />

        <Typography align="center" sx={{fontSize:"1.45rem",fontWeight:800,color:"#0B1220"}}>
          Acceso al torneo
        </Typography>

        <Typography align="center" sx={{mt:0.5,mb:3,fontSize:"0.9rem",fontWeight:400,color:"#64748B"}}>
          Ingresa con tus credenciales
        </Typography>

        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            label="Correo electrónico"
            type="email"
            fullWidth
            size="small"
            autoComplete="email"
            value={correo}
            onChange={(e)=>setCorreo(e.target.value)}
            error={Boolean(error)}
            sx={{
              mb:2,
              "& .MuiOutlinedInput-root":{
                borderRadius:"10px",
                "&.Mui-focused fieldset":{borderColor:"#155EEF"},
              },
              "& .MuiInputLabel-root.Mui-focused":{color:"#155EEF"},
            }}
          />

          <TextField
            label="Contraseña"
            type={showPassword?"text":"password"}
            fullWidth
            size="small"
            autoComplete="current-password"
            value={password}
            onChange={(e)=>setPassword(e.target.value)}
            error={Boolean(error)}
            helperText={error}
            InputProps={{
              endAdornment:(
                <InputAdornment position="end">
                  <IconButton onClick={()=>setShowPassword((value)=>!value)} edge="end" type="button" size="small">
                    {showPassword?<VisibilityOff />:<Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root":{
                borderRadius:"10px",
                "&.Mui-focused fieldset":{borderColor:"#155EEF"},
              },
              "& .MuiInputLabel-root.Mui-focused":{color:"#155EEF"},
            }}
          />

          <Button
            fullWidth
            type="submit"
            variant="contained"
            disabled={loading}
            sx={{
              height:44,
              mt:2.5,
              borderRadius:"10px",
              background:"#0B1220",
              fontWeight:700,
              textTransform:"none",
              boxShadow:"none",
              "&:hover":{
                background:"#155EEF",
                boxShadow:"none",
              },
            }}
          >
            {loading?<CircularProgress size={21} sx={{color:"#ffffff"}} />:"Iniciar sesión"}
          </Button>
        </Box>

        <Typography sx={{fontSize:"0.85rem",mt:2,textAlign:"center"}}>
          <Link component="button" type="button" underline="hover" onClick={handleBackHome} sx={{color:"#64748B",fontWeight:500}}>
            Volver al inicio
          </Link>
        </Typography>
      </Paper>
    </Box>
  );
}